<template>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="mb-2">
            <h5>
              <b-button class="mr-2" v-if="permission.edit" variant="outline-primary" :to="{ name: 'FormEdit', params: { id: item.id, model: 'relationship' }}">Edit</b-button>
              {{item.name}}
            </h5>
            <div v-if="item.directional">{{item.passive}}</div>
            <div>{{item.description}}</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import ac from '@/libs/accesscontrol'

export default {
  name: 'RelationshipSimple',
  props: ['item', 'username'],
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: async function () {
    this.permission.edit = ac.can(this.user.acgroups).updateAny('relationship').granted
  },
  data () {
    return {
      permission: {
        edit: false
      }
    }
  }
}
</script>

<style>
</style>
